import { Phone } from '../../../base/env';
import { Page } from '../../../helbest';
import { ReactComponent as CarfilloIcon } from './../../../assets/svg/carfillo-logo.svg';
import styles from './Support.module.css';

const Footer = () => (
  <div className="page-support-btn-container">
    <a
      className="page-support-btn btn-h48 mt-2 btn btn-block btn-red btn-round line-none"
      href={Phone}>
      تماس با ما
    </a>
  </div>
);

const Support = () => (
  <Page
    address="/"
    back
    className="page-support"
    footer={Footer()}
    headerFix
    logo
    mobileContainer
    show
    showFooter
    title="تماس با ما">
    <div className="container desktop-mode">
      <div className="box-page">
        <div className="page-logo">
          <CarfilloIcon className={styles.CarfilloIcon} />
        </div>
        <div>
          <p>
            جهت ارتباط با تیم پشتیبانی و رفع مشکلات خود میتوانید با کلیک کردن روی گزینه زیر با ما در
            تماس باشید.
          </p>
        </div>
        <br />
        {/* <div className="addressContainer">
          آدرس:‌ کیلومتر ۹ جاده مخصوص کرج، جنب کارخانه مینو، انبار علاءالدین
        </div> */}
      </div>
    </div>
  </Page>
);

export default Support;
